var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{staticClass:"pt-6"},[_vm._v(" Payments ")]),_c('v-card-text',[_c('v-data-table',{attrs:{"loading":_vm.loading,"items":_vm.payments,"item-key":"id","headers":_vm.headers},scopedSlots:_vm._u([{key:"item.paymentTerm",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.paymentTerm ? item.paymentTerm : "Receipt")+" ")]}},{key:"item.amount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("dollarsCents")(item.amount))+" ")]}},{key:"item.subscriptionCharges",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("dollarsCents")(item.subscriptionCharges))+" ")]}},{key:"item.clicksBilled",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("dollarsCents")(item.clicksBilled))+" ")]}},{key:"item.avgClickPrice",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("dollarsCents")(item.avgClickPrice))+" ")]}},{key:"item.avgCallPrice",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("dollarsCents")(item.avgCallPrice))+" ")]}},{key:"item.callsBilled",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("dollarsCents")(item.callsBilled))+" ")]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"outlined":"","fab":"","x-small":"","color":"primary","to":{
            name: 'paymentShow',
            params: {
              companyId: _vm.$route.params.companyId,
              paymentId: item.id
            }
          }}},[_c('v-icon',[_vm._v("mdi-eye")])],1),_c('v-btn',{attrs:{"loading":_vm.pendingInvoiceId === item.id,"outlined":"","fab":"","x-small":"","color":"primary","to":{
            name: 'paymentShow',
            params: {
              companyId: _vm.$route.params.companyId,
              paymentId: item.id,
              download: true
            }
          }}},[_c('v-icon',[_vm._v("mdi-download")])],1)]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }